// extracted by mini-css-extract-plugin
export var headerCell = "_5k-1";
export var loadingSpinnerContainer = "_5k-4";
export var rowWrapper = "_5k-3";
export var standaloneTable = "_5k-5";
export var table = "_5k-0";
export var white = "_5k-2";